import Config from '../../config/index';
import { getInstance } from './get';

function updateTransformConfig(): void {
    let instance: MatrixInstance = getInstance();
    let stageTransformData: FreeObjMap = instance.transformData();

    Config.set({
        moduleName: 'transform',
        key: 'scale',
        value: stageTransformData.scale
    });
    Config.set({
        moduleName: 'transform',
        key: 'x',
        value: stageTransformData.x
    });
    Config.set({
        moduleName: 'transform',
        key: 'y',
        value: stageTransformData.y
    });
}

export {
    updateTransformConfig
};
